import { FC, useContext, useMemo } from 'external/react'
import {styled, clsx} from 'external/material'
import CrossAccordion from 'components/common/CrossAccordion'
import { TeacherContext } from 'teacher/context'
import DayMoment, {MOMENT} from './DayMoment'

type DayMomentProps = {
    id: number,
}

const StyledDayMoments = styled('div')(dayMomentsStyles)

export const DayMoments: FC<DayMomentProps> =  props => {
    const {id} = props
    const {translate} = useContext(TeacherContext) as any
    const moments = useMemo(() => MOMENT.map(moment =>(
        <CrossAccordion key={moment} title={translate(`planning-rd-${moment}`)}>
            <DayMoment id={id} moment={moment} />
        </CrossAccordion>
    )), [id, translate])
    return (
    <StyledDayMoments className='day-moments'>
        <div className={clsx('header', 'label')}>{translate('day-moments')}</div>
        <div className='moments'>{moments}</div>
    </StyledDayMoments>
    )
}

function dayMomentsStyles() {

    const vflexGap = (gap:number, overrides:any = {}) => ({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: `${gap}px`,
        marginBottom: `${30}px`,
        justifyContent: 'center',
        ...overrides
    })

    return {
        padding: 0,
        '& .label': {
            margin: 0,
            marginTop: 15,
            marginBottom: 10,
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            fontSize: '1rem',
            lineHeight: '1.5',
            letterSpacing: '0.00938em',
            fontweight: '700'
        },
        '&.day-moments': {
            ...vflexGap(10),
            '& > .moments': vflexGap(20)
        }
    }
}